import React from 'react'

const PointIcon = () => {
  return (
    <svg viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" class="css-hufomd" className='h-5 w-5'>
      <path fill-rule="evenodd"
      fill='currentColor'
     clip-rule="evenodd" d="M.37 8.861c0 7.053 7.157 10.632 11.262 5.685 2.632-3.158 2.632-8.211 0-11.369C7.527-1.77.37 1.81.37 8.862Zm14.42 5.263h-2.105c-.842 1.158-1.895 2.106-3.158 2.737 2.21 0 3.895-.947 5.263-2.737Zm1.369-3.368h-2.21c-.211 1.053-.527 2-.948 2.737h2.105c.527-.737.842-1.684 1.053-2.737Zm-3.474-7.158h2.105C13.422 1.808 11.738.861 9.527.861c1.263.632 2.316 1.58 3.158 2.737Zm1.263 3.368h2.21c-.21-1.052-.526-2-1.052-2.842h-2.105c.42.842.737 1.79.947 2.842Zm.105.527v2.737h2.211V7.493h-2.21Z"></path></svg>
  )
}

export default PointIcon